import { ChangeEvent, ReactNode } from "react";

interface Props<T extends string | number> {
  onClick?: () => void;
  onChange?: (ev: ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  checked?: boolean;
  id?: string;
  value?: T;
  disabled?: boolean;
  label?: ReactNode;
}

function CheckboxBase<T extends string | number>({
  onClick,
  onChange,
  checked,
  className,
  label,
  id,
  value,
  disabled,
}: Props<T>) {
  const classNames = ["", className].join(" ");

  return (
    <div
      className={`flex items-center space-x-2${
        disabled ? " pointer-events-none" : ""
      }`}
    >
      <input
        id={id}
        checked={checked}
        className={classNames}
        onClick={onClick}
        onChange={onChange}
        type="checkbox"
        value={value}
        disabled={disabled}
        style={{
          backgroundPositionX: "5px",
        }}
      />
      {label && (
        <label
          htmlFor={id}
          className={`block cursor-pointer${disabled ? " opacity-30" : ""}`}
        >
          {label}
        </label>
      )}
    </div>
  );
}

export const Checkbox = CheckboxBase;
